import { ComponentType } from 'react';
import styled from 'styled-components';
import {
    ClickAwayProps,
    Dialog,
    DialogBaseProps,
    DialogContentElement,
    DialogHeader,
    getSpacingToken,
    getToken,
    MEDIA_QUERY,
} from '@optimus-web/core';

enum SIZES {
    small = '444px',
    medium = '674px',
    large = '904px',
    extraLarge = large,
}

const StyledDialog = styled(Dialog)`
    position: absolute;
    right: ${getSpacingToken('300')}px;
    bottom: ${getSpacingToken('300')}px;
    top: ${getSpacingToken('300')}px;
    max-width: ${({ size = 'medium' }) => SIZES[size]};
    transform: translateX(2em);

    ${DialogHeader} {
        ${MEDIA_QUERY.tabletUp} {
            flex-direction: row-reverse;
            justify-content: start;
        }
    }

    ${DialogContentElement} {
        flex: 1;
    }

    ${MEDIA_QUERY.tabletOnly} {
        width: calc(100% - ${getSpacingToken('900')}px);
    }

    ${MEDIA_QUERY.largePhoneMax} {
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        max-height: 100%;
        max-width: 100%;
        border-radius: ${getToken('borderRadius0')};
    }
`;

export type FloatingPanelBaseProps = Omit<DialogBaseProps, 'position' | 'noMaxWidth'>;
export type FloatingPanelProps = FloatingPanelBaseProps & ClickAwayProps;

export const FloatingPanel = ((props: FloatingPanelProps) => (
    <StyledDialog {...props} />
)) as ComponentType<FloatingPanelBaseProps>;
